import React, {Component} from 'react';
import {Grid} from '@material-ui/core';
import ProductCard from 'components/product-card';
import ProductDetailModal from 'components/product-detail-modal';

import styles from './styles.css';

export default class ProductGrid extends Component {
    state = {
        expandedProductID: null,
        modalProductID: null,
    }

    handlOnCloseDetail = () => {
        this.setState({expandedProductID: null});
    };

    handlOnCloseModal = () => {
        this.setState({modalProductID: null});
    };

    handleOpenDetail = (productID) => {
        this.setState({expandedProductID: productID});
    };

    handleOpenModal = (productID) => {
        this.setState({modalProductID: productID});
    };

    render() {
        if (!this.props.products.length) {
            return <div className={styles.noResults}>No se encontraron resultados.</div>;
        }
        const productModal = this.props.products.find(product => product.id === this.state.modalProductID);
        return (
            <Grid container spacing={4} className={styles.root}>
                {this.props.products.map(product => (
                    <Grid item xs={6} sm={4} key={product.id}>
                        <ProductCard
                            handleOpenDetail={this.handleOpenDetail}
                            handlOnCloseDetail={this.handlOnCloseDetail}
                            handleOpenModal={this.handleOpenModal}
                            isExpanded={this.state.expandedProductID === product.id}
                            key={product.id}
                            product={product}
                        />
                    </Grid>
                ))}
                {productModal && (
                    <ProductDetailModal handlOnCloseModal={this.handlOnCloseModal} product={productModal} />
                )}
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./components/product-grid/index.js